import service from '../../../@services'
import useStockStoreTypeContext from '../hooks/useStockStoreTypeContext'
import useFormDataGetPageDataByRequest from '../../../@hooks/useFormDataGetPageDataByRequest'
import { useRef } from 'react'
export default function useGetStockList() {
  const { stockStoreType } = useStockStoreTypeContext()
  const {
    pageData,
    loading,
    getList: baseGetList
  } = useFormDataGetPageDataByRequest(service.inventory.getStockList)
  const formData = useRef(null)
  const getList = (params = {}) => {
    if (params.formData) formData.current = params.formData
    return baseGetList({
      ...params,
      formData: { ...formData.current, stockStoreType }
    })
  }

  return {
    pageData,
    loading,
    getList
  }
}
